




































































































































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import BaseSuketCard from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketCard.vue";
import StoreSuketSehatTHT from "@/store/modules/SuketSehatTHT";
import SuketSehatTHTInputCard from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketSehatTHTInputCard.vue";
import CommonSuket, { EnSuketCategory } from "@/services/CommonSuket";
import BaseSuketTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketTabPage";

import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { getAge, formatDMYDate } from "@/utility/DateUtils";
import { storeDokter } from "@/store/modules/dokter";
import { SuketBaseWithRelationship } from "@/types/suket_sehat_tht";

import pdf from "vue-pdf";

@Component({
  components: {
    CardModalTtd,
    BaseSuketCard,
    SuketSehatTHTInputCard,
    pdf
  }
})
export default class SuketSehatTHTTabPage extends BaseSuketTabPage {
  @Prop() declare readonly register: string | number;

  allowedUnit = ["05", "2C", "2Q"];
  suketSvc = new CommonSuket(EnSuketCategory.SehatTht);
  suketStore = StoreSuketSehatTHT;

  get pdfUrl() {
    return this.dataSuket
      ? this.getSuketPdfUrl(EnSuketCategory.SehatTht, this.dataSuket.id)
      : null;
  }

  register_id = this.register;
  pasien_rm = this.pasien.rm;
  unit_id = this.user.unit_id;
  nama = this.pasien.nama;
  umur = getAge(formatDMYDate(this.pasien.tgl_lahir))
    .toString()
    .concat(" Th");
  pekerjaan = this.pasien.pekerjaan;
  // alamat = this.dataSuket?.content.alamat || this.pasien.alamat;
  keadaan = null;
  surat_date = new Date();
  signee_user_id = this.user.id;
  creator_user_id = this.user.id;
  alamat_type = "ktp";
  kegunaan = null;
  hidung = null;
  telinga = null;
  tenggorokan = null;

  validasi = [v => !!v || "*Kolom ini harus diisi"];
  saving = false;
  showInputTujuan = true;
  loadedRatio = 0;
  keadaanOptions = [
    {
      id: 1,
      name: "Tidak Sehat"
    },
    {
      id: 2,
      name: "Sehat THT"
    }
  ];

  @Watch("loadedRatio")
  changeLoadedRatio(val) {
    console.log("change loaded ratio", val);
  }

  mounted() {
    this.register_id = this.dataSuket?.register_id || this.register;
    this.pasien_rm = this.dataSuket?.pasien_rm || this.pasien.rm;
    this.unit_id = this.dataSuket?.unit_id || this.user.unit_id;
    this.nama = this.pasien.nama;
    this.umur =
      this.dataSuket?.pasien.umur_th ||
      getAge(formatDMYDate(this.pasien.tgl_lahir))
        .toString()
        .concat(" Th");
    this.pekerjaan = this.pasien.pekerjaan;
    this.keadaan = this.dataSuket?.content.keadaan || null;
    this.surat_date = this.dataSuket?.surat_date || new Date();
    this.signee_user_id = this.dataSuket?.signee_user_id || this.user.id;
    this.creator_user_id = this.dataSuket?.creator_user_id || this.user.id;
    this.alamat_type = this.dataSuket?.content.alamat_type;
    this.kegunaan = this.dataSuket?.content.kegunaan;
    this.hidung = this.dataSuket?.content.hasil.hidung;
    this.telinga = this.dataSuket?.content.hasil.telinga;
    this.tenggorokan = this.dataSuket?.content.hasil.tenggorokan;
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  get alamatOptions() {
    const opts = [
      {
        id: "ktp",
        name: this.pasien.alamat,
        category: "Alamat KTP"
      }
    ];

    if (this.pasien.alamat_domisili) {
      opts.push({
        id: "domisili",
        name: this.pasien.alamat_domisili,
        category: "Alamat Domisili"
      });
    }

    return opts;
  }

  get user() {
    return userModule.user;
  }

  get input() {
    return {
      register_id: this.register_id,
      pasien_rm: this.pasien_rm,
      unit_id: this.unit_id,
      content: {
        alamat_type: this.alamat_type,
        keadaan: this.keadaan,
        hasil: {
          hidung: this.hidung,
          telinga: this.telinga,
          tenggorokan: this.tenggorokan
        },
        kegunaan: this.kegunaan
      },
      surat_date: this.surat_date,
      signee_user_id: this.signee_user_id,
      creator_user_id: this.creator_user_id
    };
  }

  get listDokter() {
    return storeDokter.list;
  }

  get canSign() {
    return this.user.id == this.signee_user_id;
  }

  save() {
    if (!this.saving) {
      this.saving = true;

      const action = this.dataSuket
        ? this.suketSvc.update(this.dataSuket.id, this.input)
        : this.suketSvc.create(this.input);

      action
        .then(() => {
          if (this.canSign) {
            this.showSignatureModal();
          }

          appModule.NoticeDelay("Berhasil Simpan");

          this.close();
          StoreSuketSehatTHT.getSuketByRegister(this.register);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  close() {
    this.expandInput = false;
  }

  @Watch("dataSuket")
  changeDataSuket(val: SuketBaseWithRelationship) {
    if (val) {
      this.register_id = val.register_id;
      this.pasien_rm = val.pasien_rm.toString();
      this.unit_id = val.unit_id;
      this.umur = val.pasien.umur_th;
      this.alamat_type = val.content.alamat_type;
      this.keadaan = val.content.keadaan;
      this.hidung = val.content.hasil.hidung;
      this.telinga = val.content.hasil.telinga;
      this.tenggorokan = val.content.hasil.tenggorokan;
      this.kegunaan = val.content.kegunaan;
      this.surat_date = val.surat_date;
      this.signee_user_id = val.signee_user_id;
      this.creator_user_id = val.creator_user_id;
    } else {
      this.register_id = this.register;
      this.pasien_rm = this.pasien.rm;
      this.unit_id = this.user.unit_id;
      this.umur = getAge(formatDMYDate(this.pasien.tgl_lahir))
        .toString()
        .concat(" Th");
      this.alamat_type = "ktp";
      this.keadaan = null;
      this.hidung = null;
      this.telinga = null;
      this.tenggorokan = null;
      this.kegunaan = null;
      this.surat_date = new Date();
      this.signee_user_id = this.user.id;
      this.creator_user_id = this.user.id;
    }
  }
}
